module.exports = __webpack_public_path__ + "img/loading.969a4b0a.svg";